module.exports = __webpack_public_path__ + "img/76.7.Chla.3a179176.png";